import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Eye, EyeOff, Loader2, LogIn } from "lucide-react";
import "./style.css";
import reqEmpresa from "../../services/reqMultiTenant/reqColaborador";
import { HandleAddLocationStorage } from "../../util/libLocalStorage";
import { ContextGlobal } from "../../context";

const URL_SITE = "https://szsistemas.com.br";

const destaques = ["Vendas e caixa em tempo real", "Financeiro, boletos e fiscal", "Estoque e cadastros"];

const classeCampo =
	"h-12 w-full rounded-xl border-[1px] border-solid border-gray-200 bg-gray-50 pl-4 text-gray-900 outline-none transition focus:border-[#245bb5] focus:bg-white focus:ring-4 focus:ring-[#245bb5]/10 disabled:opacity-60";

function Marca({ clara = false }) {
	return (
		<span className="flex items-center gap-2">
			<span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-[#245bb5] to-[#0e3ba4] text-lg font-bold text-white shadow-md">
				SZ
			</span>
			<span className="flex flex-col leading-none">
				<span className={`text-xl font-bold tracking-tight ${clara ? "text-white" : "text-gray-900"}`}>
					Sistemas
				</span>
				<span
					className={`mt-1 text-[10px] font-bold uppercase tracking-widest ${clara ? "text-blue-200" : "text-[#245bb5]"}`}
				>
					Gestão inteligente
				</span>
			</span>
		</span>
	);
}

function Login() {
	const { setListPermissionsData, setModulopermitted, lastPermissionsFetchRef } = useContext(ContextGlobal);

	const [email, setEmail] = useState("");
	const [senha, setSenha] = useState("");
	const [mensagemDeErro, setMensagemDeErro] = useState("");
	const [loading, setLoading] = useState(false);
	const [mostrarSenha, setMostrarSenha] = useState(false);

	async function processaLogin(e) {
		try {
			setLoading(true);
			e.preventDefault();

			const body = { email, senha };

			const response = await reqEmpresa.login(body);

			const collaboratorData = response.data.colaborador[0];

			await HandleAddLocationStorage(collaboratorData);

			const responseApps = response.data.colaborador.map((item) => ({
				modulo: item.modulo,
				status: item.status_modulo,
				dataExpiracao: item.data_expiracao,
				dias_restantes: item.dias_restantes,
			}));

			setModulopermitted(responseApps);
			setListPermissionsData(collaboratorData);
			lastPermissionsFetchRef.current = Date.now();

			// await HandleAddAppsLocationStorage(responseApps);
			handleOpenAdmin();
		} catch (error) {
			setMensagemDeErro(error.message);
		} finally {
			setLoading(false);
		}
	}

	const navigate = useNavigate();
	const handleOpenAdmin = () => {
		// window.location.assign("/admin");
		navigate("/");
		// window.location.assign("/");
	};

	return (
		<div className="flex min-h-screen bg-gray-50 font-sans">
			<aside className="fundo-grade relative hidden w-1/2 flex-col justify-between overflow-hidden bg-[#0e3ba4] p-12 text-white lg:flex">
				<div
					aria-hidden
					className="pointer-events-none absolute -right-40 -top-40 h-[32rem] w-[32rem] rounded-full bg-blue-400/30 blur-3xl"
				/>

				<a href={URL_SITE} className="relative no-underline">
					<Marca clara />
				</a>

				<div className="relative max-w-md">
					<h1 className="mb-4 text-4xl font-bold leading-tight">Sua gestão em qualquer lugar</h1>
					<p className="mb-8 text-lg text-blue-100">
						Acompanhe o seu negócio pelo computador ou pelo celular.
					</p>
					<ul className="mb-0 space-y-3 pl-0">
						{destaques.map((destaque) => (
							<li key={destaque} className="flex items-center gap-3 text-lg font-semibold">
								<CheckCircle2 className="h-6 w-6 shrink-0 text-emerald-400" />
								{destaque}
							</li>
						))}
					</ul>
				</div>

				<p className="relative mb-0 text-sm text-blue-200">
					© {new Date().getFullYear()} SZ Sistemas. Tecnologia completa com atendimento próximo.
				</p>
			</aside>

			<main className="flex w-full items-center justify-center py-12 pl-4 pr-4 lg:w-1/2">
				<div className="w-full max-w-md">
					<div className="mb-8 flex justify-center lg:hidden">
						<Marca />
					</div>

					<form className="rounded-3xl bg-white p-8 shadow-xl ring-1 ring-black/5 sm:p-10">
						<h2 className="mb-1 text-2xl font-bold text-gray-900">Acesse sua conta</h2>
						<p className="mb-8 text-gray-500">Portal do administrador</p>

						<label htmlFor="email" className="mb-2 block text-sm font-semibold text-gray-700">
							E-mail
						</label>
						<input
							type="email"
							onChange={(e) => setEmail(e.target.value)}
							className={`${classeCampo} mb-[1.25rem] pr-4`}
							id="email"
							placeholder="nome@empresa.com.br"
							disabled={loading}
						/>

						<div className="mb-2 flex items-center justify-between">
							<label htmlFor="senha" className="block text-sm font-semibold text-gray-700">
								Senha
							</label>
							<Link to="/recovery" className="text-sm font-medium text-[#245bb5] no-underline hover:underline">
								Esqueceu a senha?
							</Link>
						</div>
						<div className="relative mb-6">
							<input
								type={mostrarSenha ? "text" : "password"}
								onChange={(e) => setSenha(e.target.value)}
								className={`${classeCampo} pr-12`}
								id="senha"
								placeholder="Sua senha"
								disabled={loading}
							/>
							<button
								type="button"
								onClick={() => setMostrarSenha(!mostrarSenha)}
								className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-700"
								aria-label={mostrarSenha ? "Esconder senha" : "Mostrar senha"}
							>
								{mostrarSenha ? <EyeOff size={20} /> : <Eye size={20} />}
							</button>
						</div>

						{mensagemDeErro?.length > 0 ? (
							<div
								className="mb-[1.25rem] rounded-xl border-l-4 border-solid border-red-500 bg-red-50 px-[1rem] py-[0.75rem] text-sm font-medium text-red-700"
								role="alert"
							>
								{mensagemDeErro}
							</div>
						) : null}

						<button
							onClick={processaLogin}
							className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[#245bb5] font-semibold text-white shadow-[0_10px_25px_-5px_rgba(36,91,181,0.4)] transition hover:bg-[#1e4b8f] active:scale-[0.98] disabled:opacity-70"
							disabled={loading}
						>
							{loading ? (
								<>
									<Loader2 size={20} className="animate-spin" />
									Enviando...
								</>
							) : (
								<>
									<LogIn size={20} />
									Acessar
								</>
							)}
						</button>
					</form>

					<a
						href={URL_SITE}
						className="mt-6 flex items-center justify-center gap-2 text-sm font-medium text-gray-500 no-underline hover:text-[#245bb5]"
					>
						<ArrowLeft size={16} />
						Voltar para o site
					</a>
				</div>
			</main>
		</div>
	);
}

export default Login;
